module.exports = function() {
  return new Worker(__webpack_public_path__ + "c0885f6f03ebbf4c4f00.worker.js");
};